var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.acceptedContract)?_c('AdContractAccepted',{attrs:{"value":_vm.value},on:{"input":_vm.close}}):_c('AdContractPending',{attrs:{"value":_vm.value},on:{"input":_vm.close}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }